import React from 'react'
import './Contact.css'

const Contact = () => {
  return (
    <div className='contact'>
        <h3>We are located at : </h3>
        <p>Lorem, ipsum dolor. <br />
            Lorem ipsum dolor sit amet.
        </p>
        <h4  className='contactMargin' >Call us </h4>
        <a href="tel: 1234-****-***">1234-****-***</a>
        <h4  className='contactMargin' >Mail us at</h4>
        <a href="mailto:someone***@example***.com">someone***@example***.com</a>
    </div>
  )
}

export default Contact